import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";

export default function standart() {}

export const FillTableCallBack = (result, page_number, columnList) => {
  var oTable = $("#example").dataTable();
  window.$mm_obligations_Glist = [];
  if (page_number === 1) {
    oTable.fnClearTable();
  }
  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      $.each(result.data, function (index, data) {
        var circleType =
          data.content["algemeen-actief"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var checkbox =
          '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';

        var algemeenCode = data.content["algemeen-code"];
        if (typeof algemeenCode === "undefined") {
          algemeenCode = "";
        } else algemeenCode = '<a href="javascript:void(0)">' + data.content["algemeen-code"] + "</a>";

        var omschrijving = data.content["algemeen-omschrijving"];
        if (typeof omschrijving === "undefined") {
          omschrijving = "";
        }
        var boekingsnummer = data.content["algemeen-boekingsnummer"];
        if (typeof boekingsnummer === "undefined") {
          boekingsnummer = "";
        }

        var datumaanvang = data.content["algemeen-datumaanvang"];
        if (typeof datumaanvang == "undefined" || datumaanvang === "NaN-NaN-NaN" || datumaanvang === "") {
          datumaanvang = "";
        } else {
          datumaanvang = Common.FormatDate(
            data.content["algemeen-datumaanvang"],
            "date"
          );
        }
        var datumoplevering = data.content["algemeen-datumoplevering"];
        if (typeof datumoplevering === "undefined" || datumoplevering === "NaN-NaN-NaN" || datumoplevering === "" ) {
          datumoplevering = "";
        } else {
          datumoplevering = Common.FormatDate(
            data.content["algemeen-datumoplevering"],
            "date"
          );
        }

        var organisatie = data.content["algemeen-organisatie"];
        if (typeof organisatie === "undefined") {
          organisatie = "";
        }
        var opdrachtgever = data.content["algemeen-opdrachtgever"];
        if (typeof opdrachtgever === "undefined") {
          opdrachtgever = "";
        }
        var directievoeder = data.content["algemeen-directievoeder"];
        if (typeof directievoeder === "undefined") {
          directievoeder = "";
        }
        var toezichthouder = data.content["algemeen-toezichthouder"];
        if (typeof toezichthouder === "undefined") {
          toezichthouder = "";
        }
        var eenheid = data.content["algemeen-eenheid"];
        if (typeof eenheid === "undefined") {
          eenheid = "";
        }
        var werkplan = data.content["algemeen-werkplan"];
        if (typeof werkplan === "undefined") {
          werkplan = "";
        }
        var budget = data.content["algemeen-budget"];
        if (typeof budget === "undefined") {
          budget = "";
        }

        var model = {
          identification: data.identification,
          algemeenCode: algemeenCode,
          algemeenCodeBase: data.content["algemeen-code"],
          omschrijving: omschrijving,
          boekingsnummer: boekingsnummer,
          datumaanvang: datumaanvang,
          datumoplevering: datumoplevering,
          opdrachtgever: opdrachtgever,
          directievoeder: directievoeder,
          eenheid: eenheid,
          eenheidsprijs: data.content["algemeen-eenheidsprijs"],
          totaal: data.content["algemeen-kostentotaal"],
          kostenPerJaar: data.content["algemeen-kostenperjaar"],
          opmerking: data.content["algemeen-opmerking"],
          akkoord: data.content["algemeen-akkoord"],
          isActive: data.content["algemeen-actief"],
          budget: data.content["algemeen-budget"],
          werkplan: data.content["algemeen-werkplan"],
          organisatie: data.content["algemeen-organisatie"],
          directievoerder: data.content["algemeen-directievoeder"],
          toezichthouder: data.content["algemeen-toezichthouder"],
        };
        // that.Glist.push(model);
        window.$mm_obligations_Glist.push(model);

        var test = {
          checkbox: checkbox,
          active: circleType,
          Code: algemeenCode,
          Omschrijving: omschrijving,
          Boekingsnummer: boekingsnummer,
          "Datum aanvang": datumaanvang,
          "Datum oplevering": datumoplevering,
          Organisatie: organisatie,
          Opdrachtgever: opdrachtgever,
          Directievoeder: directievoeder,
          Toezichthouder: toezichthouder,
          Eenheid: eenheid,
          Werkplan: werkplan,
          Budget: budget,
        };

        var _columnList = [];
        for (let column in columnList.column_list) {
          for (let key in test) {
            if (
              columnList.column_list[column].toLowerCase() == key.toLowerCase()
            ) {
              _columnList.push(test[key]);
            }
          }
        }

        var addId = oTable.fnAddData(
          [
            ..._columnList,
            // checkbox,
            // circleType,
            // algemeenCode,
            // omschrijving,
            // boekingsnummer,
            // datumaanvang,
            // datumoplevering,
            // organisatie,
            // opdrachtgever,
            // directievoeder,
            // toezichthouder,
            // eenheid,
            // werkplan,
            // budget,
          ],
          false
        );

        var theNode = $("#example").dataTable().fnSettings().aoData[
          addId[0]
        ].nTr;
        theNode.setAttribute("rowId", data["identification"]);
      });
      oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }
  $("#total-rows").html(result.meta.total_found);
  window.$mm_obligations_table_total_row_count = result.meta.total_found;
  $("#cover-spin").hide(0);
  window.$mm_obligations_treeChangeStatus = true;
  window.$mm_obligations_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id === "obligations-code") {
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_code.push(data);
    });
  }
  if (data.id === "obligations-omschrijving") {
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_omschrijving.push(data);
    });
  }
  if (data.id === "obligations-boekingsnummer") {
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_boekingsnummer.push(data);
    });
  }
  if (data.id === "obligations-organisatie") {
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_organisatie.push(data);
    });
  }
  if (data.id === "obligations-opdrachtgever") {
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_opdrachtgever.push(data);
    });
  }
  if (data.id === "obligations-directievoeder") {
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_directievoeder.push(data);
    });
  }
  if (data.id === "obligations-toezichthouder") {
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_toezichthouder.push(data);
    });
  }
  if (data.id === "obligations-eenheid") {
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_eenheid.push(data);
    });
  }
  if (data.id === "obligations-werkplan") {
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_werkplan.push(data);
    });
  }
  if (data.id === "obligations-budget") {
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_budget.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-code") {
    window.$mm_obligations_filter_code.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_code.push(data);
    });
  }
  if (searchId === "algemeen-omschrijving") {
    window.$mm_obligations_filter_omschrijving.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_omschrijving.push(data);
    });
  }
  if (searchId === "algemeen-boekingsnummer") {
    window.$mm_obligations_filter_boekingsnummer.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_boekingsnummer.push(data);
    });
  }
  if (searchId === "algemeen-organisatie") {
    window.$mm_obligations_filter_organisatie.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_organisatie.push(data);
    });
  }
  if (searchId === "algemeen-opdrachtgever") {
    window.$mm_obligations_filter_opdrachtgever.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_opdrachtgever.push(data);
    });
  }
  if (searchId === "algemeen-directievoeder") {
    window.$mm_obligations_filter_directievoeder.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_directievoeder.push(data);
    });
  }
  if (searchId === "algemeen-toezichthouder") {
    window.$mm_obligations_filter_toezichthouder.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_toezichthouder.push(data);
    });
  }
  if (searchId === "algemeen-eenheid") {
    window.$mm_obligations_filter_eenheid.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_eenheid.push(data);
    });
  }
  if (searchId === "algemeen-werkplan") {
    window.$mm_obligations_filter_werkplan.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_werkplan.push(data);
    });
  }
  if (searchId === "algemeen-budget") {
    window.$mm_obligations_filter_budget.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_obligations_filter_budget.push(data);
    });
  }
};

export function SubmitCallBack(token) {
  Common.sleep(1500).then(() => {
    $("#obligations_toevoegen_modal").modal("hide");
    window.$mm_obligations_refresh();
    /*omnimap
      .FillTableAction(window.$mm_obligations_lastUsedTableFilter, 1, token)
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
}

export const BeheereenheidEditCallBack = (token) => {
  Common.sleep(1500).then(() => {
    window.$mm_obligations_refresh();
    /*omnimap
      .FillTableAction(window.$mm_obligations_lastUsedTableFilter, 1, token)
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const RowsDeletedCallBack = (token) => {
  Common.sleep(500).then(() => {
    $("#management-units-mappen_beheren_delete_modal").modal("hide");
    window.$mm_obligations_refresh();
    /*omnimap
      .FillTableAction(window.$mm_obligations_lastUsedTableFilter, 1, token)
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const GetActionsOfRowCallback = async (result) => {
  var actionsOfSelection = [];
  var actionsOfDisabled = [];
  var BreakException = {};

  $.each(result.data.stages, function (index, stage) {
    if (stage.definition.type === "activity" && stage.start_allowed === true) {
      actionsOfSelection.push(stage.definition.identification);
    } else {
      actionsOfDisabled.push(stage.definition);
    }
  });

  $("#myPopup").html("");
  $.each(window.$catalog_management_units_actions, function (index, action) {
    if ($.inArray(action["id"], actionsOfSelection) !== -1) {
      var anchor = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: action["id"] })
        .addClass(action["class"] + " catalog-action")
        .html(action["text"]);
      $("#myPopup").append(anchor);
    }
  });

  //** aktif olmayan actionlar burada listeleniyor. */
  $.each(actionsOfDisabled, function (index, action) {
    var anchor = $("<a disabled></a>")
      .attr({ href: "javascript:void(0)", id: action["identification"] })
      .addClass("disabled" + " catalog-action")
      .html(action["name"]);
    $("#myPopup").append(anchor);
  });
  var isDelete = true;
  if (result.data.stages.length > 0) {
    let arr = window.$catalog_management_units_selectedIds;
    for (let i = 0; i < arr.length; i++) {
      let getRowOfDetail = await omnimap.GetRowOfDetailAction(
        arr[i],
        window.$catalog_management_units_token
      );

      if (
        getRowOfDetail.data.delete_allowed &&
        getRowOfDetail.data.delete_allowed !== undefined
      ) {
        // var verwijderen = $("<a></a>")
        //   .attr({ href: "javascript:void(0)", id: "verwijderen" })
        //   .addClass("trash-bin beheereenheid")
        //   .html("Verwijderen");
        // $("#myPopup").append(verwijderen);
        // break;
        isDelete = true;
      } else {
        // var verwijderen = $('<a style="cursor: no-drop;color: #ccc;"></a>')
        //   .attr({ href: "javascript:void(0)", id: "" })
        //   .addClass("trash-bin beheereenheid")
        //   .html("Verwijderen");
        // verwijderen.append(
        //   `<span class="tooltiptext" style="top: 165px;">kan niet worden verwijderd<br>omdat het in beheerobjects</span>`
        // );
        // $("#myPopup").append(verwijderen);
        // break;

        isDelete = false;
        break;
      }
    }
    if (isDelete) {
      var verwijderen = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: "verwijderen" })
        .addClass("trash-bin beheereenheid")
        .html("Verwijderen");
      $("#myPopup").append(verwijderen);
    } else {
      var verwijderen = $('<a style="cursor: no-drop;color: #ccc;"></a>')
        .attr({ href: "javascript:void(0)", id: "" })
        .addClass("trash-bin beheereenheid")
        .html("Verwijderen");
      verwijderen.append(
        `<span class="tooltiptext" style="top: 165px;">kan niet worden verwijderd<br>omdat het in beheerobjects</span>`
      );
      $("#myPopup").append(verwijderen);
    }
  } else {
    var beheereenheidToevoegen = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "beheereenheid_toevoegen" })
      .addClass("maatregelen beheereenheid")
      //.html("Toevoegen aan verplichtingen");
      .html("Verplichting toevoegen");
    $("#myPopup").append(beheereenheidToevoegen);
  }
  var popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
};

export const GetColumnPropertiesCallBack = (data, callType) => {
  var filteredRes = data.data.find((item, i) => {
    if (item.identification === process.env.REACT_APP_CATALOG_MEASURES) {
      return i;
    }
  });

  // var result_data =
  //   data.data[process.env.REACT_APP_NODE_ENV == "staging" ? 9 : 2].schema
  //     .properties.algemeen.properties;
  var result_data = filteredRes.schema.properties.algemeen.properties;
  window.$mm_obligations_columnList.forEach(function (item) {
    if (item.haveSelect && item.selectProperties != null) {
      if (callType == "create") {
        const selectStatus = document.getElementById(item.createId);
        while (selectStatus.firstChild) {
          selectStatus.removeChild(selectStatus.lastChild);
        }

        if (!item.createRequired) {
          var option = document.createElement("option");
          option.text = "Selecteer";
          option.style = "display:none;";
          selectStatus.add(option);
        }

        result_data[item.selectProperties].enum.forEach((element) => {
          var option = document.createElement("option");
          option.text = element;
          option.value = element;
          selectStatus.add(option);
        });
      } else if (callType == "edit") {
        const editSelectStatus = document.getElementById(item.editId);
        if (editSelectStatus && editSelectStatus.firstChild != null) {
          while (editSelectStatus.firstChild) {
            editSelectStatus.removeChild(editSelectStatus.lastChild);
          }
        }
        result_data[item.selectProperties].enum.forEach((element) => {
          if (item.editId) {
            var option = document.createElement("a");
            option.attributes.href = "javascript:void(0)";
            option.className = "popuptext-dropdown-a";
            option.name = item.editId;
            option.innerText = element;
            editSelectStatus.appendChild(option);
          }
        });
      }
    }
  });
};

export const GetColumnPropertiesForModelCallBack = (
  result,
  itemId,
  callType
) => {
  window.$catalog_measures_column_list.forEach(function (item) {
    if (item.id === itemId) {
      if (callType == "create") {
        const selectStatus = document.getElementById(item.createId);
        while (selectStatus.firstChild) {
          selectStatus.removeChild(selectStatus.lastChild);
        }
        if (!item.createRequired) {
          var option = document.createElement("option");
          option.text = "Selecteer";
          option.style = "display:none;";
        }

        selectStatus.add(option);
        result.data.forEach((element) => {
          var option = document.createElement("option");
          option.text = element.name;
          option.value = element.identification;
          selectStatus.add(option);
        });
      } else if (callType == "edit") {
        const editSelectStatus = document.getElementById(item.editId);
        if (editSelectStatus && editSelectStatus.firstChild != null) {
          while (editSelectStatus.firstChild) {
            editSelectStatus.removeChild(editSelectStatus.lastChild);
          }
        }
        result.data.forEach((element) => {
          if (item.editId) {
            var option = document.createElement("a");
            option.attributes.href = "javascript:void(0)";
            option.className = "popuptext-dropdown-a";
            option.name = item.editId;
            option.innerText = element.name;
            option.id = element.identification;
            editSelectStatus.appendChild(option);
          }
        });
      }
    }
  });
};

export function TableColumnChangeHandler(
  settings,
  data,
  identification,
  columnOrderReference,
  COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
) {
  var names = settings.aoColumns;
  if (names[0]) {
  }
  var test_list = [];
  names.forEach((element, index) => {
    test_list.push(element.sTitle);
  });

  var checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
  test_list[checkIndex] = "checkbox";
  var statusIndex = test_list.findIndex((x) => x.includes("bfc3e97d"));
  test_list[statusIndex] = "active";

  const model = Object.assign({}, window.$mm_obligations_units_column_order_post_model)
  model.code = "COLUMN_ORDER"
  model.client_identification = COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
  model.reference = columnOrderReference

  model.data.table_sorting.find(
      (x) => x.name === "management-maintenance>obligations"
  ).column_list = test_list

  omnimap.GetFreeFormatAction(identification, "PUT", model);

  return model.data.table_sorting[0];
}
